import { render } from "./Instagram.vue?vue&type=template&id=a4688bf0"
const script = {}
script.render = render

export default script